import { render, staticRenderFns } from "./newGroup.vue?vue&type=template&id=50eb5906&scoped=true&"
import script from "./newGroup.vue?vue&type=script&lang=ts&"
export * from "./newGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50eb5906",
  null
  
)

export default component.exports